var map = {
	"./clause_letter101.png": "7ziv",
	"./clause_letter102.png": "qjbH",
	"./clause_letter104.png": "zVjK",
	"./clause_letter111.png": "tLQy",
	"./clause_letter112.png": "BcZj",
	"./clause_letter116.png": "uqQy",
	"./clause_letter117.png": "By7I",
	"./clause_letter132.png": "p+za",
	"./clause_letter133.png": "rcKB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WZVA";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book ^\.\/clause_letter.*\.png$
// module id = WZVA
// module chunks = 1